import React, { FunctionComponent } from 'react';
import { Alert, Button, Grid, Link, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

import {
  Participant,
  StepsInfo,
} from '/src/domain/challenges/ChallengeProtocolData';
import { trimName } from '/src/domain/shared/trimName';
import * as Humanize from 'humanize-plus';

import { ClubLogo, ClubLogoSize } from '../../shared/ClubLogo';
import { Avatar, AvatarSize } from '../../shared/Avatar';
import { ParticipantBadge, ParticipantBadgeType } from './ParticipantBadge';
import { links } from '/src/domain/shared/links';
const defaultAvatar = require('/src/assets/icons/defaultAvatar.svg');

export type ParticipantInfoProps = {
  participant: Participant;
  comment?: string;
  stepsInfo?: StepsInfo;
  googleConnected?: boolean;
};

export const ParticipantInfo: FunctionComponent<ParticipantInfoProps> = ({
  participant,
  comment,
  stepsInfo,
  googleConnected,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const profileLink = links.profileLink + '?';

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <Avatar
          avatarUrl={participant.avatarUrl || defaultAvatar}
          size={AvatarSize.PROTOCOL}
          premium={participant.isPremium}
          className={classes.avatar}
        />
        <ClubLogo
          className={classes.clubLogoAvatar}
          size={ClubLogoSize.SMALL}
          url={participant.clubLogoUrl}
        />
        <div className={classes.infoContainer}>
          <Link
            underline="hover"
            href={profileLink + participant.id}
            className={classes.participantName}
          >
            {trimName(participant.firstName, participant.lastName)}
          </Link>
          <ParticipantSteps
            participantId={participant.id}
            stepsInfo={stepsInfo}
          />
        </div>
      </div>
      {/* {stepsInfo && !googleConnected && (
        <Alert severity="error">{t("trackerNotConnected")}</Alert>
      )} */}
    </div>
  );
};

type ParticipantsStepsProps = {
  participantId: string;
  stepsInfo?: StepsInfo;
};

export const ParticipantSteps: FunctionComponent<ParticipantsStepsProps> = ({
  participantId,
  stepsInfo,
}) => {
  const { t } = useTranslation();

  if (!stepsInfo) return null;

  const stepsCount = stepsInfo[participantId] ?? 0;

  return (
    <>
      <span>
        &nbsp;-&nbsp;{Humanize.formatNumber(stepsCount)}{' '}
        {t('stepsLabelCount')}
      </span>
    </>
  );
};

const useStyles = makeStyles((muiTheme) => ({
  clubLogoAvatar: {
    marginLeft: '-0.5rem',
  },
  avatar: {
    marginLeft: '0.5rem',
  },
  participantName: {
    marginLeft: '1rem',
  },
  infoContainer: {
    display: 'flex',
  },
  badgeContainer: {
    display: 'flex',
    padding: '0.5rem 0.5rem 0 0.75rem',
    [muiTheme.breakpoints.down('md')]: {
      flexFlow: 'wrap',
    },
  },
  badge: {
    marginRight: '0.5rem',
    [muiTheme.breakpoints.down('md')]: {
      marginBottom: '0.5rem',
    },
  },
  startlistBtn: {
    display: 'block',
    textAlign: 'center',
    width: '20rem',
    margin: '1rem auto',
  },
  container: {
    display: 'flex',
    padding: '0.5rem 0',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
